export const CAVE_FOREGROUND_LAYER_NAMES = Object.freeze([
  "CaveWall",
  "Rocks",
  "Doors",
  "Props",
]);

const CAVE_FOREGROUND_LAYER_DEPTH_OFFSETS = Object.freeze({
  CaveWall: 0,
  Rocks: 0.1,
  Doors: 0.2,
  Props: 0.3,
});

export const getCaveForegroundTileDepth = ({
  layerName,
  tileY,
  tileSize,
  getGroundEntityDepthAt,
}) =>
  getGroundEntityDepthAt((Number(tileY) + 1) * Number(tileSize)) +
  (CAVE_FOREGROUND_LAYER_DEPTH_OFFSETS[layerName] || 0);

export const drawDepthSortedCaveForegroundLayer = (
  scene,
  { layerName, tileSize },
) => {
  const layer = scene.getLayerByName(layerName);
  if (!layer) return 0;

  let drawnTileCount = 0;
  layer.data.forEach((gid, index) => {
    if (!gid) return;
    const resolved = scene.resolveTilesetForGid(gid);
    if (!resolved) return;

    const tileX = index % layer.width;
    const tileY = Math.floor(index / layer.width);
    scene.add
      .image(
        tileX * tileSize,
        tileY * tileSize,
        resolved.textureKey,
        resolved.frame,
      )
      .setOrigin(0)
      .setDepth(
        getCaveForegroundTileDepth({
          layerName,
          tileY,
          tileSize,
          getGroundEntityDepthAt: (worldY) =>
            scene.getGroundEntityDepthAt(worldY),
        }),
      );
    drawnTileCount += 1;
  });

  return drawnTileCount;
};
